import React from 'react';

export default function SidebarMenu({ user, roles }) {
  return (
    <aside className="w-full min-w-[13rem] h-full bg-black p-4 flex flex-col items-center shrink-0">
      {/* Avatar 
      <img
        src="/user-avatar.png"
        alt="User Avatar"
        className="w-16 h-16 rounded-full mb-3 border-2 border-blue-500 object-cover"
      />*/}

      {/* Name & Roles 
      <h2 className="text-base font-semibold text-center leading-tight truncate w-full">
        {user.name}
      </h2>
      <p className="text-xs text-gray-500 text-center mb-5 truncate w-full">
        {roles.join(' + ')}
      </p>*/}

      {/* Sidebar Menu */}
      <nav className="w-full flex flex-col space-y-1 text-xl ">
        <SidebarLink icon="👤" label="My Profile" />
        {roles.includes('Freelancer') && (
          <>
            <SidebarLink icon="📁" label="My Projects" />
            <SidebarLink icon="💰" label="My Wallet" />
            <SidebarLink icon="📜" label="Subscriptions" />
          </>
        )}
        {roles.includes('Investor') && (
          <>
            <SidebarLink icon="📊" label="My Portfolio" />
            <SidebarLink icon="💸" label="Investment Reviews" />
          </>
        )}
        <SidebarLink icon="⚙️" label="Settings" />
        <SidebarLink icon="🚪" label="Logout" color="text-red-600" hover="hover:bg-red-50" />
      </nav>
    </aside>
  );
}

// 🔹 Reusable Link Component
function SidebarLink({ icon, label, href = "#", color = "text-gray-700", hover = "hover:bg-gray-100" }) {
  return (
    <a
      href={href}
      className={`flex items-center gap-2 px-3 py-2 rounded ${color} ${hover} truncate`}
    >
      <span className="text-base">{icon}</span>
      <span className="truncate">{label}</span>
    </a>
  );
}
